/** Формат файла, в котором бэкенд отдаёт выгрузки (транскрипция, заключение, список диалогов) */
export type FileDownloadFormat = 'docx' | 'pdf' | 'xlsx';

/** Инициирует скачивание по готовому адресу: временная ссылка на странице и клик по ней */
function triggerDownload(href: string, filename: string) {
  const link = document.createElement('a');

  link.href = href;
  link.download = filename; // Задаёт имя файла, под которым он сохранится
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Сохраняет полученный от бэкенда файл на диск под указанным именем.
 * Ссылка на объект освобождается сразу после старта скачивания.
 */
export function downloadFileFromBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  triggerDownload(url, filename);
  URL.revokeObjectURL(url);
}
